import axios from 'axios';

export const car_details = {
    get_car_type_model_details,
    get_details,
    get_car_details,
    get_available_slot,
    book_appointment,
    get_location,
    get_car_text_setting
};
async function book_appointment(post_data) {
    let requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    };
    return axios.post("/api/method/carrental.api.book_appointment", post_data, requestOptions)
        .then(response => {

            return response.data.message;
        })
        .catch(function (response) {
            if (response.response.data.message) {
                return Promise.reject(response.response.data.message);
            } else {
                return Promise.reject("something went wrong, please try again");
            }
        });
}
async function get_details(car_type_details) {
    let requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };

    return axios.get("/api/method/carrental.api.get_available_model_details", { params: car_type_details }, requestOptions)
        .then(response => {

            return response.data.message;
        })
        .catch(function (response) {
            if (response.response.data.message) {
                return Promise.reject(response.response.data.message);
            } else {
                return Promise.reject("something went wrong, please try again");
            }
        });
}

async function get_car_details(car_details) {
    let requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };

    return axios.get("/api/method/carrental.api.get_car_details", { params: car_details }, requestOptions)
        .then(response => {
            return response.data.message;
        })
        .catch(function (response) {
            if (response.response.data.message) {
                return Promise.reject(response.response.data.message);
            } else {
                return Promise.reject("something went wrong, please try again");
            }
        });
}

async function get_available_slot(data) {
    let requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };
    return axios.get("/api/method/carrental.api.get_available_slot", { params: data }, requestOptions)
        .then(response => {

            return response.data.message;
        })
        .catch(function (response) {
            if (response.response.data.message) {
                return Promise.reject(response.response.data.message);
            } else {
                return Promise.reject("something went wrong, please try again");
            }
        });
}


function get_car_type_model_details() {
    let requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    };
    return axios.get("/api/method/carrental.api.get_car_type_model_details", requestOptions)
        .then(response => { return response.data.message; })
        .catch(function (response) {
            return handleResponse(response);
        })
}

// function get_location(car_data) {
//     let requestOptions = {
//         headers: {
//             'Content-Type': 'multipart/form-data',
//             'Accept': '*/*'
//         },
//     };
//     return axios.get("/api/method/carrental.api.get_location", { params: car_data },  requestOptions)
//         .then(response => { console.log(response); return response; })
//         .catch(function (response) {
//             return handleResponse(response);
//         })
// }

async function get_location(data) {
    let requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    };
    return axios.get("/api/method/carrental.api.get_location", { params: data }, requestOptions)
        .then(response => {

            return response.data.message;
        })
        .catch(function (response) {
            if (response.response.data.message) {
                return Promise.reject(response.response.data.message);
            } else {
                return Promise.reject("something went wrong, please try again");
            }
        });
}


function handleResponse(error) {
    if (error.response) {
        return Promise.reject("Something went wrong, please try again.");
    } else {
        if (error.data.message.message) {
            return Promise.reject(error.data.message.message);
        } else {
            return Promise.reject("Something went wrong, please try again.");
        }
    }
}

function get_car_text_setting() {
    let requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    };
    return axios.get("/api/method/carrental.api.get_car_text_setting", requestOptions)
        .then(response => { return response.data.message; })
        .catch(function (response) {
            return handleResponse(response);
        })
}
